module.exports = __webpack_public_path__ + "img/default-img.634a74ed.jpg";